var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgContact(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Groupe_2692",
    "data-name": "Groupe 2692",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 33.855,
    height: 43.591,
    viewBox: "0 0 33.855 43.591",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_153",
    "data-name": "Rectangle 153",
    width: 33.855,
    height: 43.591,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2692-2",
    "data-name": "Groupe 2692",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_932",
    "data-name": "Trac\\xE9 932",
    d: "M6.034,10.891A10.891,10.891,0,1,1,19.568,21.459H26.1c3.444,0,5.7,2.815,6.2,6.042l1.5,9.706c.543,3.512-2.785,6.385-6.2,6.385H6.254c-3.4,0-6.74-2.853-6.2-6.384h0l1.5-9.706c.5-3.227,2.756-6.042,6.2-6.042h6.531A10.9,10.9,0,0,1,6.034,10.891M16.925,2.252a8.638,8.638,0,1,0,8.638,8.638,8.638,8.638,0,0,0-8.638-8.638M26.1,23.711H7.751c-2.278,0-3.646,2.007-3.974,4.132l-1.5,9.706h0c-.334,2.16,2,3.79,3.978,3.79,2.459,0,21.186.072,21.964-.048C30.072,41,31.889,39.4,31.57,37.549l-1.5-9.706c-.321-2.084-1.666-4.132-3.974-4.132",
    transform: "translate(0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgContact);
export default __webpack_public_path__ + "static/media/contact.2b33b5425c715d3386785eb763a66f17.svg";
export { ForwardRef as ReactComponent };